import SelectUploadForm from '../../../../../components/Purchasing/RFQ/Lines/upload/SelectUploadForm'
import UploadCompareList from '../../../../../components/Purchasing/RFQ/Lines/upload/UploadCompareList'
import React, { Component, Fragment } from 'react'
import { Button, Popconfirm, Steps } from 'antd'

const Step = Steps.Step

class UploadLines extends Component {
  render() {
    const {
      current,
      prev,
      next,
      submit,
      submitting,
      fetching,
      transactionUploadFormRef,
    } = this.props
    const steps = [
      {
        title: 'Select File',
        key: 'Select File',
        content: <SelectUploadForm ref={transactionUploadFormRef} {...this.props} />,
      },
      {
        title: 'Compare and Upload',
        key: 'Compare and Upload',
        content: <UploadCompareList {...this.props} />,
      },
    ]
    return (
      <Fragment>
        <Steps current={current}>
          {steps.map(item => (
            <Step key={item.key} title={item.title} />
          ))}
        </Steps>
        <div className="steps-action" style={{ textAlign: 'center', paddingTop: 20 }}>
          {current > 0 && (
            <Button style={{ marginRight: 8 }} onClick={() => prev()}>
              Previous
            </Button>
          )}
          {current < steps.length - 1 && (
            <Button
              style={{ width: '100px' }}
              type="primary"
              loading={fetching}
              onClick={() => next()}>
              Next
            </Button>
          )}
          {current === steps.length - 1 && (
            <Popconfirm title="Sure to submit?" onConfirm={() => submit()}>
              <Button loading={submitting} type="primary">
                Submit
              </Button>
            </Popconfirm>
          )}
        </div>
        <div style={{ marginTop: '50px', marginBottom: '10px' }} className="steps-content">
          {steps[current].content}
        </div>
      </Fragment>
    )
  }
}

UploadLines.propTypes = {}
UploadLines.defaultProps = {}

export default UploadLines
